"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _userflow = _interopRequireDefault(require("../../../../styles/userflow"));
var _emailUtils = require("../../../../utils/emailUtils");
var _Grid = _interopRequireDefault(require("../common/Grid"));
var _Spacer = _interopRequireDefault(require("../common/Spacer"));
var _Container = _interopRequireDefault(require("../Container"));
var _NPS = _interopRequireDefault(require("../NPS"));
var _Column = _interopRequireDefault(require("./Column"));
var _templateObject, _templateObject2, _templateObject3;
var assetsPath = 'https://cdn.yc.level.travel/email/cashback';
var guideSrc = "".concat(assetsPath, "/guide.png");
var cashbackIconSrc = "".concat(assetsPath, "/cashback.png");
var returnIconSrc = "".concat(assetsPath, "/return.png");
var styles = {
  container: {
    textAlign: 'center'
  },
  column: {
    height: '100%',
    verticalAlign: 'top',
    textAlign: 'center',
    padding: '0 4px'
  },
  columnTitle: {
    verticalAlign: 'middle'
  },
  columnImage: {
    verticalAlign: 'middle'
  },
  offset: {
    padding: '0 20px'
  },
  title: {
    fontSize: '20px',
    fontWeight: 500,
    lineHeight: '24px',
    color: _userflow["default"].colors.black
  },
  subtitle: {
    fontSize: '18px',
    lineHeight: '22px',
    color: _userflow["default"].colors.black
  },
  description: {
    fontSize: '16px',
    lineHeight: '20px',
    color: _userflow["default"].colors.blackBase
  },
  nobr: {
    whiteSpace: 'nowrap'
  },
  guideImage: {
    maxWidth: '580px',
    width: '100%'
  }
};
var cashbackIcon = /*#__PURE__*/_react["default"].createElement("img", {
  src: cashbackIconSrc,
  alt: "\u041A\u0435\u0448\u0431\u044D\u043A",
  style: styles.columnImage,
  height: "18px",
  width: "18px"
});
var returnIcon = /*#__PURE__*/_react["default"].createElement("img", {
  src: returnIconSrc,
  alt: "\u041A\u0435\u0448\u0431\u044D\u043A",
  style: styles.columnImage,
  height: "18px",
  width: "18px"
});
var Bonus = function Bonus(_ref) {
  var username = _ref.username,
    order_number = _ref.order_number,
    bonuses = _ref.bonuses,
    total_bonuses = _ref.total_bonuses,
    score_links = _ref.score_links;
  return /*#__PURE__*/_react["default"].createElement(_Container["default"], {
    style: styles.container,
    fullWidth: true,
    bgColor: "#fff",
    className: "offer"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    style: styles.offset
  }, /*#__PURE__*/_react["default"].createElement(_Spacer["default"], {
    size: 25
  }), /*#__PURE__*/_react["default"].createElement(Title, {
    style: styles.title
  }, "\u041A\u0435\u0448\u0431\u044D\u043A \u043F\u043E \u0437\u0430\u043A\u0430\u0437\u0443 \u2116", order_number), /*#__PURE__*/_react["default"].createElement(_Spacer["default"], {
    size: 16
  }), /*#__PURE__*/_react["default"].createElement(Subtitle, {
    style: styles.subtitle
  }, "\u0417\u0434\u0440\u0430\u0432\u0441\u0442\u0432\u0443\u0439\u0442\u0435 ", username, "! \u0412\u043E\u0442 \u0432\u0430\u0448\u0438 \u0431\u0430\u043B\u043B\u044B \u043A\u0435\u0448\u0431\u044D\u043A\u0430!"), /*#__PURE__*/_react["default"].createElement(_Spacer["default"], {
    size: 16
  }), /*#__PURE__*/_react["default"].createElement(_Grid["default"], null, /*#__PURE__*/_react["default"].createElement(_Grid["default"].Row, null, /*#__PURE__*/_react["default"].createElement(_Grid["default"].Cell, {
    style: styles.column
  }, /*#__PURE__*/_react["default"].createElement(_Column["default"], {
    title: /*#__PURE__*/_react["default"].createElement("div", {
      style: {
        lineHeight: '20px'
      }
    }, /*#__PURE__*/_react["default"].createElement("div", null, returnIcon), /*#__PURE__*/_react["default"].createElement("span", null, "1%")),
    description: "\u0417\u0430 \u043A\u0430\u0436\u0434\u044B\u0439 \u0437\u0430\u043A\u0430\u0437 \u043C\u044B \u0432\u043E\u0437\u0432\u0440\u0430\u0449\u0430\u0435\u043C 1% \u043E\u0442 \u0441\u0442\u043E\u0438\u043C\u043E\u0441\u0442\u0438 \u0442\u0443\u0440\u0430 \u0432 \u0432\u0438\u0434\u0435 \u0431\u0430\u043B\u043B\u043E\u0432"
  })), /*#__PURE__*/_react["default"].createElement(_Grid["default"].Cell, {
    style: styles.column
  }, /*#__PURE__*/_react["default"].createElement(_Column["default"], {
    title: /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("span", {
      style: styles.columnTitle
    }, bonuses), cashbackIcon),
    description: "\u0417\u0430 \u0432\u0430\u0448 \u0437\u0430\u043A\u0430\u0437 \u2116".concat(order_number, " \u043C\u044B \u043D\u0430\u0447\u0438\u0441\u043B\u044F\u0435\u043C \u0432\u0430\u043C ").concat(bonuses, " \u0431\u0430\u043B\u043B\u043E\u0432")
  })), /*#__PURE__*/_react["default"].createElement(_Grid["default"].Cell, {
    style: styles.column
  }, /*#__PURE__*/_react["default"].createElement(_Column["default"], {
    title: /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("span", {
      style: styles.columnTitle
    }, total_bonuses), cashbackIcon),
    description: /*#__PURE__*/_react["default"].createElement("div", null, "\u0422\u0435\u043F\u0435\u0440\u044C \u0432 \u0432\u0430\u0448\u0435\u043C \u043B\u0438\u0447\u043D\u043E\u043C \u043A\u0430\u0431\u0438\u043D\u0435\u0442\u0435 ", total_bonuses, " \u0431\u0430\u043B\u043B\u043E\u0432", ' ', /*#__PURE__*/_react["default"].createElement("span", {
      style: styles.nobr
    }, "(1", cashbackIcon, " = 1 \u0440\u0443\u0431\u043B\u044C)"))
  })))), /*#__PURE__*/_react["default"].createElement(_Spacer["default"], {
    size: 24
  }), /*#__PURE__*/_react["default"].createElement(Description, {
    style: styles.description
  }, "\u0418\u0441\u043F\u043E\u043B\u044C\u0437\u0443\u0439\u0442\u0435 \u043A\u0435\u0448\u0431\u044D\u043A, \u043A\u043E\u0433\u0434\u0430 \u0431\u0443\u0434\u0435\u0442\u0435 \u043E\u0444\u043E\u0440\u043C\u043B\u044F\u0442\u044C \u0432\u0430\u0448 \u0441\u043B\u0435\u0434\u0443\u044E\u0449\u0438\u0439 \u0437\u0430\u043A\u0430\u0437.", /*#__PURE__*/_react["default"].createElement("br", null), "\u0412\u043E\u0442 \u043A\u0430\u043A \u044D\u0442\u043E \u0441\u0434\u0435\u043B\u0430\u0442\u044C"), /*#__PURE__*/_react["default"].createElement("img", {
    alt: "\u0418\u043D\u0441\u0442\u0440\u0443\u043A\u0446\u0438\u044F",
    style: styles.guideImage,
    src: guideSrc
  }), /*#__PURE__*/_react["default"].createElement(_Spacer["default"], {
    size: 16
  }), /*#__PURE__*/_react["default"].createElement(_NPS["default"], {
    links: score_links
  }), /*#__PURE__*/_react["default"].createElement(_Spacer["default"], {
    size: 16
  })));
};
var Title = _styledComponents["default"].div.withConfig({
  displayName: "Bonus__Title",
  componentId: "sc-1i5w58f-0"
})(["", ""], (0, _emailUtils.mobileStyles)(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["\n    font-size: 20px !important;\n  "]))));
var Subtitle = _styledComponents["default"].div.withConfig({
  displayName: "Bonus__Subtitle",
  componentId: "sc-1i5w58f-1"
})(["", ""], (0, _emailUtils.mobileStyles)(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2["default"])(["\n    font-size: 16px !important;\n  "]))));
var Description = _styledComponents["default"].div.withConfig({
  displayName: "Bonus__Description",
  componentId: "sc-1i5w58f-2"
})(["", ""], (0, _emailUtils.mobileStyles)(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteral2["default"])(["\n    font-size: 14px !important;\n  "]))));
var _default = exports["default"] = Bonus;